<template>
  <div>
    <DataTable :headers="headers" :path="path" :filterPath="filterPath" :properties="properties"
               actionButtonsName="BoletinActionButtons" filter toolbar
               toolbar-title="Comunicaciones" search-text="Buscar por título o descripción">
    </DataTable>
    <v-btn v-if="canCreate" app dark fixed fab bottom right class="add-button" @click="newBoletin">
      <v-icon>add</v-icon>
    </v-btn>
  </div>
</template>

<script>
import DataTable from '../../../common/ui/DataTable'

export default {
  components: {
    DataTable
  },

  data () {
    return {
      headers: [
        { text: 'Fecha', value: 'fecha', align: 'left' },
        { text: 'Departamento', value: 'department', filterField: true, align: 'left' },
        { text: 'Tipo', value: 'communication_type', align: 'left' },
        { text: 'Título', value: 'title', align: 'left' },
        { text: 'Descripción', sortable: false, value: 'description', align: 'left' },
        { text: 'Club', value: 'club', filterField: true, align: 'left', visible: false },
        { text: 'Acciones', align: 'right', sortable: false }
      ],
      properties: ['fecha', 'departamento', 'communicationType', 'title', 'description'],
      path: 'bulletins',
      filterPath: 'filters/bulletins'
    }
  },

  computed: {
    canCreate () {
      return this.$store.state.permissions.canAddBoletines
    }
  },

  methods: {
    newBoletin () {
      this.$router.push({ name: 'nuevoBoletin' })
    }
  }
}
</script>
